import { render } from "./AnswerTestDialog.vue?vue&type=template&id=18656499&scoped=true"
import script from "./AnswerTestDialog.vue?vue&type=script&lang=js"
export * from "./AnswerTestDialog.vue?vue&type=script&lang=js"

import "./AnswerTestDialog.vue?vue&type=style&index=0&id=18656499&scoped=true&lang=css"
import "./AnswerTestDialog.vue?vue&type=style&index=1&id=18656499&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18656499"]])

export default __exports__